import { INITIAL_STATE, setTagReports, clearTagReports } from '../core'
import {
    RECEIVE_TAG_REPORTS,
    CLEAR_TAG_REPORTS,
} from '../action_creators'

function tagReports(state=INITIAL_STATE.tagReports, action) {
    switch (action.type) {
        case RECEIVE_TAG_REPORTS:
            return setTagReports(action.tagReports)
        case CLEAR_TAG_REPORTS:
            return clearTagReports()
        default:
            return state
    }
}

export default tagReports



// WEBPACK FOOTER //
// ./src/redux/reducers/tag_reports_reducer.js